import { fetchApiUploadFile } from "utils/helper";

export const uploadFile = async(formData: any) => {
    const data: any = await fetchApiUploadFile(formData);
    return data
}